import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CTAButton } from "./CTAButton";
type FloatingCTAProps = {
  visible: boolean;
};
export function FloatingCTA({
  visible
}: FloatingCTAProps) {
  return <AnimatePresence data-id="element-154" data-mp="1wwlbbk32ia5c">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-navy-900/10 bg-white/95 px-3 pb-[max(12px,env(safe-area-inset-bottom))] pt-3 shadow-[0_-8px_24px_-12px_rgba(10,26,63,0.35)] backdrop-blur md:border-0 md:bg-transparent md:pb-5 md:shadow-none md:backdrop-blur-none" data-id="element-155" data-mp="1wxmxajlmgh1u">
          <div className="mx-auto max-w-md" data-id="element-156" data-mp="38ayuwcqsg3fk">
            <CTAButton label="Yes, I want it — only $27" compact shake data-id="element-157" data-mp="38bqstu7uyd90" />
          </div>
        </motion.div>}
    </AnimatePresence>;
}